import { FC } from "react";
import { useMatch } from "react-router";
import { AllType, isAllType, RoutePath } from "src/data/Routes";
import NavigateRoute from "./NavigateRoute";
import { useNavProps } from "./useNavProps";

export const RouteClassTypeItem: FC = () => {
  const match = useMatch(RoutePath.MATCH_CLASS_TYPE_ITEM);
  const navProps = useNavProps(search => {
    const cls = match.params.class;
    let type = match.params.type;
    const typePath = '/' + type;
    let allType: AllType;
    if (isAllType(typePath)) {
      allType = typePath;
      type = null;
    }
    const item = match.params.item;
    return { clsName: cls, allType, typeOrDevice: type, itemName: item, search };
  }, [match.params]);

  return navProps && <NavigateRoute {...navProps} />;
};
